import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MtxDrawerRef, MTX_DRAWER_DATA } from '@ng-matero/extensions/drawer';
import { MatButtonModule } from '@angular/material/button';
import { DrawerWorkorderTitleComponent } from '../drawers/drawer-workorder-title/drawer-workorder-title.component';
import { WorkOrderDto } from 'src/api';
import { WorkOrdersRepository } from '../workorders.repository';
import { DrawerWorkorderActionsComponent } from '../drawers/drawer-workorder-actions/drawer-workorder-actions.component';
import { TranslateModule } from '@ngx-translate/core';
import { WorkOrderTranslateService } from 'src/app/shared/services/translate-workorder.service';

@Component({
  selector: 'app-workorder-reject-validate',
  standalone: true,
  templateUrl: './workorder-reject-validate.component.html',
  styleUrls: ['./workorder-reject-validate.component.scss'],
  imports: [
    CommonModule,
    DrawerWorkorderTitleComponent,
    MatButtonModule,
    DrawerWorkorderActionsComponent,
    TranslateModule,
  ],
})
export class WorkorderRejectValidateComponent {
  drawerTitle!: string;
  saveButtonIsEnable = true;

  get workOrder() {
    return this.data.workOrder;
  }

  get validateWorkOrder() {
    const title = this.data.validateWorkOrder ? 'Validate Work Order' : 'Reject Work Order';
    this.drawerTitle = this.workorderTranslateService.translateDrawerTitle(title);
    return this.data.validateWorkOrder;
  }

  constructor(
    public drawerRef: MtxDrawerRef<WorkorderRejectValidateComponent>,
    public workOrdersRepository: WorkOrdersRepository,
    private workorderTranslateService: WorkOrderTranslateService,
    @Inject(MTX_DRAWER_DATA) public data: { workOrder: WorkOrderDto; validateWorkOrder: boolean }
  ) {}

  close() {
    this.drawerRef.dismiss();
  }

  confirmWorkOrder() {
    this.workOrdersRepository.validateWorkOrder(this.workOrder.id as number);
    this.drawerRef.dismiss();
  }

  rejectWorkOrder() {
    this.workOrdersRepository.rejectWorkOrder(this.workOrder.id as number);
    this.drawerRef.dismiss();
  }
}
